var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "handle-document view" },
    [
      _c(
        "div",
        { staticClass: "view_content" },
        [
          _c("transition", { attrs: { mode: "out-in" } }, [
            _c("div", { staticClass: "view_content_markdown" }, [
              _c("h1", [
                _vm._v(
                  _vm._s(_vm.$t("document.handleDocumentContainer.title"))
                ),
              ]),
              _c("p", [
                _vm._v(_vm._s(_vm.$t("document.handleDocumentContainer.text"))),
              ]),
              _c(
                "div",
                { staticClass: "handle-document_wrapper" },
                [
                  _vm.handleDocumentStepActive === "uploadDocuments"
                    ? _c("ma-upload-document", {
                        attrs: {
                          documents: _vm.mappedDocuments,
                          loading: _vm.uploadLoading,
                          disableActions: _vm.icrLoading,
                        },
                        on: {
                          onDocumentInputChange: function ($event) {
                            return _vm.handleDocumentInputChange($event)
                          },
                          onDocumentDeleteClick: function ($event) {
                            return _vm.handleDocumentDeleteClick($event)
                          },
                          onDocumentDownloadClick: function ($event) {
                            return _vm.handleDocumentDownloadClick($event)
                          },
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]),
          ]),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "view_actions" },
        [
          _c(
            "ma-actions-buttons",
            {
              attrs: {
                handleButtonClick: _vm.handlePrimaryButtonClick,
                title: _vm.$t(
                  "document.handleDocumentContainer.actions.primary"
                ),
                mainBlueShouldBeDisabled: _vm.primaryButtonIsDisabled,
                btnType: "functionalBtn",
              },
            },
            [
              _vm.isE2EFlow
                ? _vm._t("default", function () {
                    return [
                      _c(
                        "button",
                        {
                          staticClass: "btn mainWhite",
                          on: { click: _vm.handleSecondaryButtonClick },
                        },
                        [
                          _c("p", { staticClass: "text-medium" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("damageValidation.actions.tertiary")
                              )
                            ),
                          ]),
                        ]
                      ),
                    ]
                  })
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "ma-modal",
        {
          ref: "icrProcessingModal",
          staticClass: "handle-document_icr-modal",
          attrs: { type: "full", closeIsHidden: "" },
        },
        [
          _c("template", { slot: "modalContent" }, [
            _c("div", { staticClass: "view" }, [
              _c(
                "div",
                { staticClass: "view_content" },
                [
                  _c(
                    "p",
                    {
                      staticClass:
                        "handle-document_icr-modal_title text-medium gray mg mg--b-14 center",
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "document.handleDocumentContainer.icrModal.title"
                          )
                        )
                      ),
                    ]
                  ),
                  _c(
                    "transition",
                    { attrs: { name: "fade", mode: "out-in" } },
                    [
                      _vm.icrProcessingModalTextActive === "one"
                        ? _c("div", { key: "one" }, [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "text-medium gray mg mg--b-4 center",
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "document.handleDocumentContainer.icrModal.text1"
                                    )
                                  )
                                ),
                              ]
                            ),
                            _c(
                              "p",
                              {
                                staticClass:
                                  "text-medium gray mg mg--b-14 center",
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "document.handleDocumentContainer.icrModal.text2"
                                    )
                                  )
                                ),
                              ]
                            ),
                          ])
                        : _c("div", { key: "two" }, [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "text-medium gray mg mg--b-4 center",
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "document.handleDocumentContainer.icrModal.text3"
                                    )
                                  )
                                ),
                              ]
                            ),
                          ]),
                    ]
                  ),
                  _c("ma-spinner", { attrs: { size: "large" } }),
                ],
                1
              ),
            ]),
          ]),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }